import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from '../../../linknet-common/validators/index';
import { WebshopService } from '../../../linknet-common/restful-services/restful.service';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { ToastrService } from "ngx-toastr";
import { GlobalService } from 'app/linknet-common/globals/global.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'shop-app-enquire-now',
    templateUrl: './enquire-now.component.html',
    styleUrls: ['./enquire-now.component.scss'],
})

export class EnquireNowComponent implements OnInit{
    public enquireNow: any;
    public optionsSelectSalutation: Array<any>;
    public loaderShow: Boolean = false;
    public myOptions: INgxMyDpOptions = {
      dateFormat: 'dd-mm-yyyy',
    };
    webshop:any;
    customerID:any;

    constructor(public datePipe: DatePipe, private formBuilder: FormBuilder, private _httpWebshopService: WebshopService, private toastr: ToastrService,public globalService: GlobalService){
      const d: Date = new Date();
      this.myOptions = {
        dateFormat: 'dd-mm-yyyy',
        disableUntil: { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() - 1 }
      }

        this.optionsSelectSalutation = [
            {
              'value': 'CAPT',
              'label': 'CAPT'
            },
            {
              'value': 'DR',
              'label': 'DR'
            },
            {
              'value': 'MR',
              'label': 'MR'
            },
            {
              'value': 'MRS',
              'label': 'MRS'
            },
            {
              'value': 'MISS',
              'label': 'MISS'
            },
            {
              'value': 'MS',
              'label': 'MS'
            }
        ];
      this.webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
      this.customerID = this.webshop.CustomerID;
    }

    loadForm(){
      const userSettings = this.globalService.getLoggedInData();
      this.enquireNow = this.formBuilder.group({
        'Salutation': [userSettings.Salutation, [Validators.required]],
        'FirstName': [userSettings.FirstName, [Validators.required]],
        'LastName': [userSettings.LastName, [Validators.required]],
        'CompanyName': [userSettings.CompanyName, [Validators.required]],
        'Email': [userSettings.Email, [Validators.required, ValidationService.emailValidator]],
        'Department': [userSettings.Department],
        'PhoneNumber': [userSettings.PhoneNumber, [Validators.required, Validators.maxLength(10)]],
        'DigitalProductName': [''],
        'PhysicalProductName': [''],
        'BrandName': [''],
        'ModelNo': [''],
        'Quantity': [''],
        'TargetPrice': [''],
        'RequiredBy': ['', [Validators.required]],
    });
    }

    ngOnInit() {
      this.loadForm();
    }

    onlyNumberKey(event) {
        const pattern = new RegExp('^[0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
          event.preventDefault();
          return false;
        }
    }

    proceed(){
      let board = JSON.parse(sessionStorage.getItem('billBoardList'));
      this.enquireNow.value.RequiredBy = this.datePipe.transform(this.enquireNow.value.RequiredBy.jsdate, 'dd/MM/yyyy');
      const params = {
        "Salutation": this.enquireNow.value.Salutation,
        "FirstName": this.enquireNow.value.FirstName,
        "LastName": this.enquireNow.value.LastName,
        "CompanyName": this.enquireNow.value.CompanyName,
        "Department": this.enquireNow.value.Department,
        "CompanyEmail": this.enquireNow.value.Email,
        "Mobile": this.enquireNow.value.PhoneNumber,
        "DigitalProductName": this.enquireNow.value.DigitalProductName,
        "PhysicalProductName": this.enquireNow.value.PhysicalProductName,
        "BrandName":  this.enquireNow.value.BrandName,
        "ModelNo":  this.enquireNow.value.ModelNo,
        "Quantity":  this.enquireNow.value.Quantity,
        "Target_Price": this.enquireNow.value.TargetPrice,
        "RequiredBy": this.enquireNow.value.RequiredBy,
        "BillBoardId": board[3].BillboardAdID,
        "BannerId":1,
        "CustomerId": this.customerID
      }
      this.loaderShow = true;
      this._httpWebshopService.createBanner(params).subscribe((_data)=>{
          this.loadForm();
          this.loaderShow = false;
          this.toastr.success('Enquiry submitted.')
      },_error=>{
        this.loaderShow = false;
        this.toastr.error('Please try again.')
      })
    }
}